import React, { useEffect, useState } from "react";
import { get } from "lodash/fp";
import {
  Container,
  Panel,
  Pagination,
  Table,
  Footer,
  Content,
  Button,
  Form,
  Divider,
  Modal,
  Toggle,
  Input,
  Col,
  InputGroup,
  Grid,
} from "rsuite";
import VisibleIcon from "@rsuite/icons/Visible";
import SearchIcon from "@rsuite/icons/Search";
import CloseIcon from "@rsuite/icons/Close";
import PlusIcon from "@rsuite/icons/Plus";
import CustomCell from "../../components/Elements/CustomCell";
import CustomHeaderCell from "../../components/Elements/CustomHeaderCell";
import { updateIn } from "json-immut";
import EditCell from "./EditCell";
import ActionCell from "./ActionCell";
import { AlertModal } from "../../components/Modals/AlertModal/AlertModal";
import { useTranslation } from "react-i18next";
import { HelperServices } from "../../../core/services/HelperServices";
import { UtilityServices } from "../../../core/services/UtilityServices";
import {
  statusArr,
  appConstObj,
  messageTypeArr,
} from "../../../core/config/AppConstants";
import "./Countries.css";

function Countries() {
  const { Column } = Table;
  const [loading, setLoading] = useState(false);
  const [stateLoading, setStateLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [countryData, setCountryData] = useState<any[]>([]);
  const [countryId, setCountryId] = useState("");
  const [stateId, setStateId] = useState(0);
  const [stateData, setStateData] = useState<any[]>([]);
  const [editStateData, setStateEditData] = useState<any[]>([]);
  const [countryTotal, setCountryTotal] = useState(0);
  const [countryRows, setCountryRows] = useState(appConstObj.record_per_page);
  const [countryPage, setCountryPage] = useState(1);
  const [countrySortBy, setCountrySortBy] = useState();
  const [countrySortOrder, setCountrySortOrder] = useState();
  const [stateTotal, setStateTotal] = useState(0);
  const [stateRows, setStateRows] = useState(appConstObj.record_per_page);
  const [statePage, setStatePage] = useState(1);
  const [stateSortBy, setStateSortBy] = useState();
  const [stateSortOrder, setStateSortOrder] = useState();
  const [errors, setErrors] = useState<any>({});
  const [manageCountry, setManageCountry] = useState<boolean>();
  const [manageState, setManageState] = useState<boolean>();
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [countrySmartSearch, setCountrySmartSearch] = useState<string>("");
  const [stateSmartSearch, setStateSmartSearch] = useState<string>("");
  const { t } = useTranslation();
  let stateInitVal = {
    country: "",
    name: "",
    code: "",
    status: 1,
  };
  const [stateFormData, setStateFormData] = useState<any>(stateInitVal);

  async function getCountries(params: any) {
    try {
      setLoading(true);
      const response: any = await HelperServices.getCountries(params);
      if (response.status) {
        setCountryData(get("data.data", response));
        setCountryTotal(get("data.total", response));
      } else {
        UtilityServices.showToaster({
          message: response?.data?.message,
        });
      }
      setLoading(false);
    } catch (error: any) {
      console.log(error);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
      setLoading(false);
    }
  }

  async function getStates(params: any) {
    try {
      setOpen(true);
      setStateLoading(true);
      const response: any = await HelperServices.getStates(params);
      if (response.status) {
        setStateData(get("data.data", response));
        setStateTotal(get("data.total", response));
      } else {
        UtilityServices.showToaster({
          message: response?.data?.message,
        });
      }
      setStateLoading(false);
    } catch (error: any) {
      console.log(error);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
      setStateLoading(false);
    }
  }

  const handleEditState = async (id: Number) => {
    let nextData: any = {};
    let activeItem: any = {};
    nextData = Object.assign([], stateData);
    activeItem = nextData?.find((item: any) => item.id === id);
    activeItem.editStatus = activeItem?.editStatus ? null : "EDIT";
    if (activeItem.editStatus == null) {
      let params = {
        id: activeItem.id,
        state_name: activeItem.state_name,
        state_code: activeItem.state_code,
        country_id: activeItem.country_id,
        status: activeItem.status,
      };

      try {
        setLoading(true);
        const response: any = await HelperServices.updateState(params);
        if (response.status) {
          UtilityServices.showToaster({
            message: response?.data?.message,
          });
          setStatePage(1);
          setStateFormData(stateInitVal);
          getStates({
            name: stateSmartSearch,
            country: countryId,
            page: 1,
            rows: stateRows,
            sort_by: stateSortBy,
            sort_order: stateSortOrder,
          });
        } else {
          UtilityServices.showToaster({
            message: response?.data?.message,
          });
        }

        setLoading(false);
      } catch (error: any) {
        console.log("error ", error);
        UtilityServices.showToaster({
          message: error?.message,
          type: messageTypeArr.error,
        });
        setLoading(false);
      }
    }

    setStateEditData(nextData);
  };

  const handleStateChanges = (id: Number, key: any, value: any) => {
    let nextData: any = {};
    nextData = Object.assign([], stateData);
    console.log(value);
    nextData.find((item: any) => item.id === id)[key] =
      key == "status" ? (value ? 1 : 0) : value;
    setStateEditData(nextData);
  };

  const handleClose = () => {
    setStateData([]);
    setStateFormData(stateInitVal);
    setErrors({});
    setOpen(false);
  };

  async function addState() {
    try {
      let i;
      let data = { ...stateFormData };
      data.country = countryId;
      let dumpError = { ...errors };
      for (i in data) {
        if (data[i] === "") {
          dumpError[i] = t("FIELD_REQUIRED");
          setErrors(dumpError);
        } else {
          delete dumpError[i];
          setErrors(dumpError);
        }
      }

      if (Object.keys(dumpError).length == 0) {
        setLoading(true);
        data.country_id = data.country;
        data.state_name = data.name;
        data.state_code = data.code;
        delete data.country;
        delete data.name;
        delete data.code;
        delete data.rows;
        const response: any = await HelperServices.createState(data);
        if (response.status) {
          UtilityServices.showToaster({
            message: response?.data?.message,
          });

          setStatePage(1);
          setStateFormData(stateInitVal);
          getStates({
            name: stateSmartSearch,
            country: countryId,
            page: 1,
            rows: stateRows,
            sort_by: stateSortBy,
            sort_order: stateSortOrder,
          });
        } else {
          UtilityServices.showToaster({
            message: response?.data?.message,
          });
        }
        setLoading(false);
      }
    } catch (error: any) {
      console.log("error ", error);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
      setLoading(false);
    }
  }

  const handleStateFormChange = (data: any) => {
    if (data.path == "status") {
      if (data.value) {
        data.value = 1;
      } else {
        data.value = 0;
      }
    }
    let form = updateIn(stateFormData, [data.path], data.value);
    setStateFormData(form);
  };

  const handleStateDelete = async (stateId: number) => {
    try {
      setLoading(true);
      const response: any = await HelperServices.deleteState(stateId);
      if (response.status) {
        UtilityServices.showToaster({
          message: response?.data?.message,
        });
        setStatePage(1);
        getStates({
          name: stateSmartSearch,
          country: countryId,
          page: 1,
          rows: stateRows,
          sort_by: stateSortBy,
          sort_order: stateSortOrder,
        });
      } else {
        UtilityServices.showToaster({
          message: response?.data?.message,
        });
      }
      setLoading(false);
    } catch (error: any) {
      console.log(error);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
      setLoading(false);
    }
  };

  function onCountryPageChange(page: number) {
    setCountryPage(page);
    getCountries({
      smart_search: countrySmartSearch,
      page: page,
      rows: countryRows,
      sort_by: countrySortBy,
      sort_order: countrySortOrder,
    });
  }

  function onCountrySortChange(dataKey: any, sortType: any) {
    setCountryPage(1);
    setCountrySortBy(dataKey);
    setCountrySortOrder(sortType);
    getCountries({
      smart_search: countrySmartSearch,
      page: 1,
      rows: countryRows,
      sort_by: dataKey,
      sort_order: sortType,
    });
  }

  const handleCountryChangeRows = (rows: any) => {
    setCountryPage(1);
    setCountryRows(rows);
    getCountries({
      smart_search: countrySmartSearch,
      page: 1,
      rows: rows,
      sort_by: countrySortBy,
      sort_order: countrySortOrder,
    });
  };

  function onStatePageChange(page: number) {
    setStatePage(page);
    getStates({
      name: stateSmartSearch,
      country: countryId,
      page: page,
      rows: stateRows,
      sort_by: stateSortBy,
      sort_order: stateSortOrder,
    });
  }

  function onStateSortChange(dataKey: any, sortType: any) {
    setStatePage(1);
    setStateSortBy(dataKey);
    setStateSortOrder(sortType);
    getStates({
      country: countryId,
      page: 1,
      rows: stateRows,
      sort_by: dataKey,
      sort_order: sortType,
    });
  }

  const handleStateChangeRows = (rows: any) => {
    setStatePage(1);
    setStateRows(rows);
    getStates({
      name: stateSmartSearch,
      country: countryId,
      page: 1,
      rows: rows,
      sort_by: stateSortBy,
      sort_order: stateSortOrder,
    });
  };

  const filterStates = (e: any) => {
    if ((e.key === "Enter" || e.type === "click") && stateSmartSearch != "") {
      getStates({
        page: 1,
        rows: stateRows,
        country: countryId,
        sort_by: stateSortBy,
        sort_order: stateSortOrder,
        name: stateSmartSearch,
      });
    }
  };

  const clearStateSmartSearch = () => {
    if (stateSmartSearch != "") {
      setStateSmartSearch("");
      setStateSortBy(undefined);
      setStateSortOrder(undefined);
      setStatePage(1);
      setStateRows(appConstObj.record_per_page);
      getStates({
        page: 1,
        rows: appConstObj.record_per_page,
        country: countryId,
      });
    }
  };

  const filterCountries = (e: any) => {
    let search: any = {
      page: 1,
      rows: countryRows,
      sort_by: countrySortBy,
      sort_order: countrySortOrder,
    };
    if (e.key === "Enter" || e.type === "click") {
      if (countrySmartSearch != "") {
        search.smart_search = countrySmartSearch;
        getCountries(search);
      } else {
        getCountries(search);
      }
    }
  };

  const clearCountrySmartSearch = () => {
    if (countrySmartSearch != "") {
      setCountrySmartSearch("");
      setCountrySortBy(undefined);
      setCountrySortOrder(undefined);
      setCountryPage(1);
      setCountryRows(appConstObj.record_per_page);
      getCountries({
        page: 1,
        sort_by: undefined,
        sort_order: undefined,
        rows: appConstObj.record_per_page,
      });
    }
  };

  async function init() {
    try {
      setManageCountry(UtilityServices.hasPermission("manage-country"));
      setManageState(UtilityServices.hasPermission("manage-state"));
    } catch (error: any) {
      console.log(error);
    }
  }

  useEffect(() => {
    init();
    getCountries({
      page: countryPage,
      rows: countryRows,
      sort_by: countrySortBy,
      sort_order: countrySortOrder,
    });
  }, []);

  return (
    <div className="users cntry">
      <Container className="container">
        <Panel>
          <Grid fluid>
            <h4>{t("COUNTRIES")}</h4>
          </Grid>
          <div className="row">
            <div className="col-md-4 mb-2 mt-3 text-right">
              <InputGroup>
                <Input
                  className="form-control"
                  placeholder={t("SMART_SEARCH_BY", {
                    entity:
                      t("NAME").toLowerCase() +
                      ", " +
                      t("SHORT_CODE").toLowerCase() +
                      ", " +
                      t("LONG_CODE").toLowerCase() +
                      " " +
                      t("STD_CODE").toLowerCase(),
                  })}
                  value={countrySmartSearch}
                  onChange={(val: any) => setCountrySmartSearch(val)}
                  onKeyDown={(e: any) => filterCountries(e)}
                />
                <InputGroup.Button
                  title={t("SEARCH")}
                  onClick={(e: any) => filterCountries(e)}
                >
                  <SearchIcon />
                </InputGroup.Button>
                <InputGroup.Button
                  title={t("CLEAR")}
                  onClick={() => clearCountrySmartSearch()}
                >
                  <CloseIcon />
                </InputGroup.Button>
              </InputGroup>
            </div>
          </div>
          <Content>
            <Table
              loading={loading}
              height={400}
              fillHeight={true}
              data={countryData}
              hover={true}
              onSortColumn={onCountrySortChange}
              sortColumn={countrySortBy}
              sortType={countrySortOrder}
              bordered
              cellBordered
            >
              <Column fixed flexGrow={1} align="left" sortable>
                <CustomHeaderCell>{t("NAME")}</CustomHeaderCell>
                <CustomCell dataKey="country_name" />
              </Column>

              <Column flexGrow={1} align="center" sortable>
                <CustomHeaderCell>{t("SHORT_CODE")}</CustomHeaderCell>
                <CustomCell dataKey="country_code_short" />
              </Column>

              <Column flexGrow={1} align="center" sortable>
                <CustomHeaderCell>{t("LONG_CODE")}</CustomHeaderCell>
                <CustomCell dataKey="country_code_long" />
              </Column>

              <Column flexGrow={1} align="center" sortable>
                <CustomHeaderCell>{t("STD_CODE")}</CustomHeaderCell>
                <CustomCell dataKey="country_std_code" />
              </Column>

              <Column flexGrow={1} align="center" sortable>
                <CustomHeaderCell>{t("REGION")}</CustomHeaderCell>
                <CustomCell dataKey="region" />
              </Column>

              <Column flexGrow={1} align="center" sortable>
                <CustomHeaderCell>{t("CURRENCY")}</CustomHeaderCell>
                <CustomCell dataKey="currency_name" />
              </Column>

              <Column flexGrow={1} align="center">
                <CustomHeaderCell>{t("STATUS")}</CustomHeaderCell>
                <CustomCell dataKey="status">
                  {(rowData: any) => {
                    return rowData.status ? t("Active") : t("Inactive");
                  }}
                </CustomCell>
              </Column>

              <Column flexGrow={1} align="center">
                <CustomHeaderCell>{t("ACTION")}</CustomHeaderCell>
                <CustomCell>
                  {(rowData: any) => {
                    return (
                      <a
                        href="javascript:void(0)"
                        onClick={(e: any) => {
                          setCountryId(rowData.id);
                          handleStateFormChange({
                            path: "country",
                            value: rowData.id,
                          });
                          getStates({
                            page: statePage,
                            country: rowData.id,
                            rows: stateRows,
                          });
                        }}
                        title={t("VIEW")}
                      >
                        <VisibleIcon />
                      </a>
                    );
                  }}
                </CustomCell>
              </Column>
            </Table>
          </Content>
          <Footer className="footer">
            <Pagination
              total={countryTotal}
              prev
              next
              first
              last
              ellipsis
              boundaryLinks
              maxButtons={5}
              size="xs"
              layout={["total", "-", "limit", "|", "pager", "skip"]}
              limitOptions={appConstObj.limit_options}
              limit={countryRows}
              activePage={countryPage}
              onChangePage={onCountryPageChange}
              onChangeLimit={handleCountryChangeRows}
            />
          </Footer>
        </Panel>
      </Container>

      <Modal
        size={"md"}
        open={open}
        overflow={true}
        onClose={handleClose}
        onExited={() => {
          return true;
        }}
      >
        <Modal.Header  className="mb-2">
          <Modal.Title><h4 className="text-center">{t("STATE_LIST")}</h4></Modal.Title>          
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Form layout="inline" formValue={stateFormData}>
            <Col md={5}>
              <Form.Group controlId="status-7">
                <span>{t("STATUS")}:{" "}</span>
                <Toggle
                  defaultChecked
                  onChange={(v: any) =>
                    handleStateFormChange({ path: "status", value: v })
                  }
                />
              </Form.Group>
              </Col>
              <Col md={7}>
                <Form.Control
                  className={errors["name"] ? "is-invalid" : ""}
                  name="name"
                  size="sm"
                  placeholder="State Name"
                  onChange={(v: any) =>
                    handleStateFormChange({ path: "name", value: v })
                  }
                />
                <span className="text-danger">{errors["name"]}</span>
              </Col>

              <Col md={7}>
                <Form.Control
                  className={errors["code"] ? "is-invalid" : ""}
                  name="code"
                  size="sm"
                  placeholder="Code"
                  onChange={(v: any) =>
                    handleStateFormChange({ path: "code", value: v })
                  }
                />
                <span className="text-danger">{errors["code"]}</span>
              </Col>
              
              <Col md={2}>
              {manageState ? (
                <Button onClick={addState} appearance="ghost" className="mb-2">
                  {t("SAVE")}
                </Button>
              ) : (
                ""
              )}
              </Col>
            </Form>
          </Container>
          <div className="row">
            <div className="col-md-7"></div>
            <div className="col-md-5 mb-2 text-right">
              <InputGroup>
                <Input
                  className="form-control"
                  placeholder={t("SMART_SEARCH_BY", {
                    entity: t("STATE_NAME").toLowerCase(),
                  })}
                  value={stateSmartSearch}
                  onChange={(val: any) => setStateSmartSearch(val)}
                  onKeyDown={(e: any) => filterStates(e)}
                />
                <InputGroup.Button
                  title={t("SEARCH")}
                  onClick={(e: any) => filterStates(e)}
                >
                  <SearchIcon />
                </InputGroup.Button>
                <InputGroup.Button
                  title={t("CLEAR")}
                  onClick={() => clearStateSmartSearch()}
                >
                  <CloseIcon />
                </InputGroup.Button>
              </InputGroup>
            </div>
          </div>
          <React.Fragment>
            <Table
              loading={stateLoading}
              autoHeight={true}
              height={100}
              data={stateData}
              onSortColumn={onStateSortChange}
              sortColumn={stateSortBy}
              sortType={stateSortOrder}
              bordered
              cellBordered
            >
              <Column flexGrow={1} align="left" fixed>
                <CustomHeaderCell>{t("STATE_NAME")}</CustomHeaderCell>
                <EditCell dataKey="state_name" onChange={handleStateChanges} />
              </Column>

              <Column flexGrow={1} align="center" fixed>
                <CustomHeaderCell>{t("CODE")}</CustomHeaderCell>
                <EditCell dataKey="state_code" onChange={handleStateChanges} />
              </Column>

              <Column flexGrow={1} align="center">
                <CustomHeaderCell>{t("STATUS")}</CustomHeaderCell>
                <EditCell dataKey="status" onChange={handleStateChanges} />
              </Column>

              {manageState ? (
                <Column flexGrow={1} align="center">
                  <CustomHeaderCell>{t("ACTION")}</CustomHeaderCell>
                  <ActionCell
                    dataKey="id"
                    onClick={handleEditState}
                    onDelete={(id: any) => {
                      setOpenDeleteModal(true);
                      setStateId(id);
                    }}
                  />
                </Column>
              ) : (
                ""
              )}
            </Table>
          </React.Fragment>
          <Footer className="footer">
            <Pagination
              total={stateTotal}
              prev
              next
              first
              last
              ellipsis
              boundaryLinks
              maxButtons={5}
              size="xs"
              layout={["total", "-", "limit", "|", "pager", "skip"]}
              limitOptions={appConstObj.limit_options}
              limit={stateRows}
              activePage={statePage}
              onChangePage={onStatePageChange}
              onChangeLimit={handleStateChangeRows}
            />
          </Footer>
        </Modal.Body>
      </Modal>

      <AlertModal
        open={openDeleteModal}
        handleClose={(e: any) => {
          if (e == true) {
            handleStateDelete(stateId);
            setOpenDeleteModal(false);
          } else {
            setOpenDeleteModal(false);
          }
        }}
        displayText={t("CONFIRM_ACTION", {
          action: t("DELETE").toLowerCase(),
          entity: t("STATE").toLowerCase(),
        })}
        modalTitle={t("CONFIRM_ACTION_TITLE", {
          action: t("STATE").toLowerCase(),
        })}
      />
    </div>
  );
}

export default Countries;
